import Typography from '@components/typography'
import { StatsWrapper } from './IssuesHeader.styles'
import { TableTitleWrapper } from '@/ui/components/CustomTable/CustomTable.styles'
import { PdfIssuesExport } from '@/ui/routes/issues/components/pdfIssues/pdfIssuesExport'
import { IssuesStats } from '@/ui/components/IssuesStats'

const IssuesHeader = ({
    filteredIssues,
    allIssues,
}: {
    filteredIssues: TIssue[]
    allIssues: TIssue[]
}) => {
    const numberOfOpenIssues = allIssues.filter(
        (issue) => issue.status === 'open'
    ).length

    const numberOfIssues = allIssues.length

    return (
        <StatsWrapper>
            <TableTitleWrapper>
                <Typography variant="m-regular">Security Issues</Typography>
                <PdfIssuesExport
                    issues={allIssues}
                    filteredIssues={filteredIssues}
                />
            </TableTitleWrapper>
            <IssuesStats
                leftCount={numberOfIssues}
                leftDescription="Total Issues"
                rightCount={numberOfOpenIssues}
                rightDescription="Open Issues"
            />
        </StatsWrapper>
    )
}

export default IssuesHeader
